module.exports = __webpack_public_path__ + "media/images/img-realestate-5-36f8ba7d.png";